export default __webpack_public_path__ + "static/media/scene_1.a020f39b.png";